/**
 * Two letters for a person whose initials nobody sent us.
 *
 * Every CLIENT carries `PersonRef.initials` off the wire, so this is not for them — it exists for
 * the one person the contract never describes that way: **the signed-in trainer**, whose identity
 * comes out of the session rather than out of a `PersonRef`.
 *
 * Promoted out of `app/ui/AccountMenu.tsx` on 9 September 2026, on its second consumer — the
 * library drawer's `Źródło` facet, where "Moje" is marked with the trainer's own avatar and falls
 * back to their letters. Two copies of a rule about how a name becomes two characters would drift
 * the first time one of them met a hyphenated surname.
 *
 * Letters are taken by CODE POINT (`[...name]`), not by UTF-16 code unit: `slice(0, 1)` and
 * `charAt` both cut a name opening on an astral character in half and render a replacement box.
 * Same answer for every Polish letter, a whole character at the edge.
 */
export function displayInitials(displayName: string): string {
  const parts = displayName.trim().split(/\s+/).filter(Boolean);
  const first = parts.at(0);
  const last = parts.at(-1);
  // Never empty and never "undefined": a blank name still has to draw something inside the disc.
  if (first === undefined || last === undefined) return '?';
  if (parts.length === 1) return [...first].slice(0, 2).join('').toUpperCase();
  return `${[...first][0]}${[...last][0]}`.toUpperCase();
}
